import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaCalendarAlt,
  FaClipboardList,
  FaUser,
  FaServicestack,
  FaBars,
  FaTimes,
  FaGlobe
} from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { useLanguage } from "./LanguajeContext";
import translations from "../utils/sideBar.translate";

const navItems = [
  { to: "/dashboard/available", key: "availability", icon: <FaCalendarAlt /> },
  { to: "/dashboard/service", key: "service", icon: <FaServicestack /> },
  { to: "/dashboard/booking", key: "booking", icon: <FaClipboardList /> },
  { to: "/dashboard/profile", key: "profile", icon: <FaUser /> },
];

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const { language, setLanguage } = useLanguage();
  
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  return (
    <>
      {/* Botón de hamburguesa para móviles - POSICIÓN AJUSTADA */}
      <button
        onClick={toggleSidebar}
        className="fixed lg:hidden z-30 top-5 left-5 p-3 rounded-full bg-[#1E2B3A] text-white shadow-lg hover:bg-[#2D4A5E] transition-colors"
        aria-label="Menú de navegación"
        style={{ marginTop: '0.75rem' }} // Alineado con el Topbar
      >
        {isOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
      </button>

      {/* Fondo oscuro para móviles */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden transition-opacity ${
          isOpen ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"
        }`}
        onClick={toggleSidebar}
      />

      {/* Sidebar */}
      <aside
        className={`
          fixed top-0 left-0 h-full w-64 bg-[#1E2B3A] shadow-2xl z-40
          transform transition-transform duration-300 ease-in-out
          ${isOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0 lg:static lg:z-auto
        `}
      >
        <div className="h-full flex flex-col justify-between border-r border-[#33475b] overflow-y-auto">
          <div className="p-4 lg:p-6">
            <div className="flex justify-between items-center mb-6 lg:mb-8">
              <h1 className="text-xl lg:text-2xl font-extrabold text-white tracking-wide">
                {translations[language].operator}
              </h1>
              <button
                onClick={toggleSidebar}
                className="lg:hidden p-1 text-gray-300 hover:text-white"
              >
                <FaTimes size={20} />
              </button>
            </div>

            <nav className="flex flex-col gap-1 lg:gap-2">
              {navItems.map(({ to, key, icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  onClick={toggleSidebar}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-3 py-2 lg:px-4 lg:py-3 rounded-lg lg:rounded-xl transition duration-200 text-sm font-medium ${
                      isActive
                        ? "bg-green-400 text-[#102B3F]"
                        : "text-gray-300 hover:bg-[#2D4A5E] hover:text-white"
                    }`
                  }
                >
                  <span className="text-base lg:text-lg">{icon}</span>
                  <span className="truncate">{translations[language][key]}</span>
                </NavLink>
              ))}
            </nav>
          </div>

          <div className="p-4 lg:p-6 border-t border-[#33475b] space-y-4">
            <div className="flex items-center gap-2 text-sm text-gray-300">
              <FaGlobe className="text-base lg:text-lg" />
              <span className="truncate">{translations[language].language}:</span>
              <select 
                value={language} 
                onChange={handleLanguageChange}
                className="bg-[#2D4A5E] text-white rounded p-1 text-xs"
              >
                <option value="es">ES</option>
                <option value="en">EN</option>
              </select>
            </div>
            
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 w-full text-sm text-red-300 hover:text-red-500 transition font-medium"
            >
              <FiLogOut className="text-base lg:text-lg" />
              <span className="truncate">{translations[language].logout}</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}